// 埋點事件的中文對照。來源:USER_EVENT_TRACKING_SPEC 第 3 節事件字典(Android/iOS 共用同一組字串)。
//
// 設計上「事件清單由實際資料決定,不由這張表決定」——後端是掃 device_local_data 實際出現的事件,
// 這裡只負責翻譯。所以:
//   - App 之後新增而這裡還沒補的事件,頁面照樣顯示(退回顯示原始英文字串),不會消失。
//   - 這裡有、但 App 還沒埋的事件,不會憑空出現一排 0。
// 兩邊都不需要同步維護才能正確運作。

export const PAGE_LABEL: { [key: string]: string } = {
    login: '登入註冊',
    tour: '新手導覽',
    explore: '探索',
    search: '搜尋',
    rank: '排行榜',
    popular: '必追熱門',
    profile: '對象個人頁',
    preview: '個人頁預覽',
    chat_list: '聊天列表',
    chat: '1:1 聊天室',
    album: '私密相簿',
    voice_call: '語音通話',
    video_call: '視訊通話',
    dynamic: '動態列表',
    dynamic_detail: '動態詳情',
    media_wall: '媒體牆',
    me: '個人主頁',
    top_up: '儲值頁',
    member: '會員任務',
    fee: '收費設定',
    gift_redeem: '實體禮物兌換',
    records: '交易紀錄',
    relation: '粉絲/追蹤列表',
    reward: '獎勵兌換',
    upload: '媒體上傳',
    date_list: '約會列表',
    date_detail: '約會詳情',
    date_publish: '發布約會',
    live: '視訊直播間',
    live_create: '開播設定',
    voice_entrance: '語音房預覽',
    voice_room: '語音房',
    voice_create: '開語音房設定',
    guess_game: '你畫我猜',
    turntable: '轉盤遊戲',
    toy: '玩具設定',
    toy_pair: '通話中玩具配對',
    feedback: '客服/意見回饋',
    report: '檢舉',
    bulletin: '公告',
    promotion: '行銷活動',
    _unknown: '未分類',
};

export const EVENT_LABEL: { [key: string]: string } = {
    // 登入與引導
    login_enter: '進入登入/註冊頁',
    login_submit_phone: '送出手機號碼',
    login_submit_sms_code: '送出簡訊驗證碼',
    login_select_gender: '選擇性別',
    login_submit_register: '完成註冊送出',
    tour_enter: '進入新手導覽',
    tour_finish: '結束導覽',

    // 探索
    explore_enter: '進入探索頁',
    explore_click_user_card: '點擊使用者卡片',
    explore_click_follow: '點擊推薦卡片追蹤',
    explore_play_voice_intro: '播放語音自介',
    explore_click_search: '點擊搜尋',
    explore_click_rank: '點擊排行榜入口(女)',
    explore_click_popular: '點擊必追熱門入口(男)',
    explore_click_income_report: '點擊收益報表入口(女)',
    explore_click_banner: '點擊活動 banner',
    explore_enter_voice_room: '從探索進語音房',
    search_enter: '進入搜尋頁',
    search_submit_search: '送出搜尋',
    search_click_result: '點擊搜尋結果',
    rank_enter: '進入排行榜',
    rank_click_user: '點擊榜上使用者',
    popular_enter: '進入必追熱門',
    popular_click_user_card: '點擊使用者卡片',

    // 對象個人頁
    profile_enter: '進入他人個人頁',
    profile_click_follow: '點擊追蹤',
    profile_click_fee_info: '查看收費資訊(男)',
    profile_click_send_message: '點擊發訊息',
    profile_click_gift_menu: '打開送禮選單(男)',
    profile_click_send_gift: '送出禮物(男)',
    profile_click_send_sticker: '送出貼圖(男)',
    profile_click_activity_gift: '送出活動禮包(男)',
    profile_click_interaction: '點擊互動快捷',
    profile_click_report: '點擊檢舉',
    profile_click_block: '封鎖使用者',
    profile_switch_dynamic_tab: '切到動態分頁',
    profile_switch_info_tab: '切到關於他分頁',
    profile_enter_live: '從個人頁進直播間',
    profile_enter_voice_room: '從個人頁進語音房',
    preview_enter: '進入自己個人頁預覽',

    // 聊天
    chat_list_enter: '進入聊天列表',
    chat_list_click_chat_item: '點擊聊天項目',
    chat_list_click_mass_send: '點擊小飛機群發',
    chat_list_click_service: '點擊官方客服',
    chat_list_click_voice_room_invite: '點頭像進直播/語音房',
    chat_list_click_top_up: '點擊儲值入口(男)',
    chat_enter: '進入 1:1 聊天室',
    chat_send_message: '發送文字訊息',
    chat_click_voice_call: '點擊撥打語音',
    chat_click_video_call: '點擊撥打視訊',
    chat_click_gift_menu: '打開送禮選單',
    chat_click_send_gift: '送出禮物(男)',
    chat_click_send_sticker: '送出貼圖',
    chat_click_private_note: '點擊私密筆記(女)',
    chat_click_private_album: '點擊私密相簿(男)',
    chat_click_canned_message: '使用罐頭訊息',
    chat_click_voice_record: '點擊錄音訊息',
    chat_click_report: '點擊檢舉',
    chat_click_unlock_media: '解鎖付費媒體(男)',
    album_enter: '進入私密相簿',
    album_click_view_media: '點擊瀏覽媒體',

    // 通話
    voice_call_enter: '進入語音通話',
    voice_call_click_accept: '接聽來電',
    voice_call_click_refuse: '拒接/取消撥號',
    voice_call_click_hang_up: '掛斷通話',
    voice_call_toggle_mic: '開關麥克風',
    voice_call_toggle_speaker: '開關擴音',
    voice_call_click_game: '開啟小遊戲',
    voice_call_click_video_order: '開啟指令選單',
    video_call_enter: '進入視訊通話',
    video_call_click_accept: '接聽來電',
    video_call_click_refuse: '拒接/取消撥號',
    video_call_click_hang_up: '掛斷通話',
    video_call_toggle_mic: '開關麥克風',
    video_call_toggle_camera: '開關鏡頭',
    video_call_switch_camera: '翻轉前後鏡頭',
    video_call_click_beauty: '開啟美顏(女)',
    video_call_click_filter: '開啟濾鏡(女)',
    video_call_click_game: '開啟小遊戲',
    video_call_click_video_order: '開啟視訊點播選單',
    video_call_click_toy_invite: '玩具發起邀請',
    video_call_click_toy_free_mode: '玩具自由模式',
    video_call_click_toy_repeat_mode: '玩具重複模式',

    // 動態
    dynamic_enter: '進入動態頁',
    dynamic_switch_tab_follow: '切到關注 Tab',
    dynamic_switch_tab_featured: '切到精選 Tab',
    dynamic_click_like: '按讚動態',
    dynamic_click_avatar: '點擊頭像',
    dynamic_click_unlock_media: '解鎖付費動態',
    dynamic_detail_enter: '進入動態詳情',
    dynamic_detail_click_send_gift: '送出禮物(男)',
    dynamic_detail_click_unlock_media: '解鎖付費媒體',
    dynamic_detail_click_report: '點擊檢舉',
    dynamic_detail_click_avatar: '點擊發布者',
    media_wall_enter: '進入媒體牆',

    // 個人 Tab
    me_enter: '進入個人主頁',
    me_click_top_up: '點擊儲值入口(男)',
    me_click_fee_setting: '點擊收費設定(女)',
    me_click_records: '點擊交易紀錄(男)',
    me_click_income_report: '點擊收益報表(女)',
    me_click_fans: '點擊粉絲列表',
    me_click_follows: '點擊追蹤列表',
    me_click_member: '點擊會員任務',
    me_click_create_live: '點擊開直播/語音房(女)',
    me_click_upload_media: '點擊上傳動態',
    me_click_self_rank: '查看自己排名(女)',
    me_click_preview: '點擊個人頁預覽',
    top_up_enter: '進入儲值頁',
    top_up_click_product: '點擊購買鑽石產品',
    member_enter: '進入會員任務頁',
    member_click_rule: '查看規則說明',
    member_click_activity_income: '查看活動收益',
    fee_enter: '進入收費/收益設定',
    fee_click_income_report: '查看收益報表',
    fee_click_vip_fee: '點擊 VIP 收費設定',
    gift_redeem_enter: '進入實體禮物兌換',
    gift_redeem_click_redeem: '兌換禮物',
    records_enter: '進入交易紀錄',
    relation_enter: '進入粉絲/追蹤列表',
    relation_click_user: '點擊使用者',
    reward_enter: '進入獎勵兌換',
    reward_click_exchange: '送出兌換碼',
    upload_enter: '進入媒體上傳頁',
    upload_click_publish: '發布上傳',

    // 約會
    date_list_enter: '進入約會列表',
    date_list_switch_tab_find: '切到找約會 Tab(男)',
    date_list_switch_tab_mine: '切到我的約會 Tab',
    date_list_click_create: '點擊發起約會(女)',
    date_list_click_card: '點擊約會卡片',
    date_detail_enter: '進入約會詳情',
    date_detail_click_join: '報名參加約會(男)',
    date_detail_click_participants: '查看參加者',
    date_publish_enter: '進入發布約會頁',
    date_publish_click_publish: '送出發布',

    // 直播
    live_enter: '進入直播間',
    live_click_donate: '送禮/斗內',
    live_click_gift_price: '查看禮物價目',
    live_send_message: '發送彈幕訊息',
    live_click_send_sticker: '送出貼圖',
    live_click_follow: '追蹤主播(iOS 限定)',
    live_click_vip_chat: '申請 VIP 私聊(男)',
    live_click_task: '開啟任務面板',
    live_click_vote: '開啟投票面板',
    live_click_audience: '查看觀眾列表',
    live_click_host_info: '查看主播資訊卡',
    live_click_share: '分享直播間',
    live_click_diamond_info: '點擊鑽石資訊',
    live_create_enter: '進入開播設定頁',
    live_create_click_start: '開始直播',

    // 語音房
    voice_entrance_enter: '進入語音房預覽',
    voice_entrance_click_enter: '點擊進入房間',
    voice_room_enter: '進入語音房',
    voice_room_click_mic_seat: '點擊麥位',
    voice_room_send_message: '發送聊天訊息',
    voice_room_click_send_sticker: '送出貼圖',
    voice_room_click_send_gift: '送出禮物(男)',
    voice_room_click_contribute: '查看貢獻榜',
    voice_room_click_mission: '開啟任務面板',
    voice_room_click_vote: '開啟投票面板',
    voice_room_click_instruction: '開啟指令面板',
    voice_room_click_invite: '邀請用戶上麥',
    voice_room_click_notify_fans: '通知粉絲',
    voice_room_click_leave: '離開/關閉房間',
    voice_room_click_report: '點擊檢舉',
    voice_create_enter: '進入開房設定',
    voice_create_click_create: '建立房間',

    // 遊戲與玩具
    guess_game_enter: '進入你畫我猜',
    turntable_enter: '進入轉盤遊戲',
    toy_enter: '進入玩具設定頁',
    toy_click_pair: '配對/連線裝置',
    toy_pair_enter: '開啟通話中配對面板',
    toy_pair_click_scan: '重新掃描',
    toy_pair_click_device: '點選裝置連線',

    // 其他
    feedback_enter: '進入客服/意見回饋',
    feedback_submit: '送出回饋表單',
    report_enter: '進入檢舉流程',
    report_submit: '送出檢舉',
    bulletin_enter: '進入公告頁',
    promotion_enter: '進入活動列表',
    promotion_click_item: '點擊活動項目',
};

/** 事件的行為類型。判定是子字串比對,所以順序有意義。
 *  ⚠ _click_ 必須排在 _send_ 之前:規格裡有 9 個事件長成 {page}_click_send_{目標}
 *  (profile_click_send_message / chat_click_send_gift / voice_room_click_send_sticker …),
 *  它們含有 _send_ 子字串,但依規格第 2.2 節屬於「點擊」而非「送出類」。
 *  真正的送出類只有 chat_send_message / live_send_message / voice_room_send_message 三個。
 *  switch / toggle / submit 留在 click 之前是安全的:規格裡沒有任何事件同時含 _click_ 與這三者。 */
export function eventKind(event: string): string {
    if (!event) { return 'other'; }
    if (event.indexOf('_switch_') > -1) { return 'switch'; }
    if (event.indexOf('_toggle_') > -1) { return 'toggle'; }
    if (event.indexOf('_submit') > -1) { return 'submit'; }
    if (event.indexOf('_click_') > -1) { return 'click'; }
    if (event.indexOf('_send_') > -1) { return 'send'; }
    if (event.indexOf('_enter') > -1) { return 'enter'; }
    return 'other';
}

export const KIND_LABEL: { [key: string]: string } = {
    enter: '進入頁面',
    click: '點擊',
    send: '送出',
    submit: '送出表單',
    switch: '切換',
    toggle: '開關',
    other: '其他',
};
